import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class HotelService {
  static gethotelList(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.gethotel}?id=${item?.id}`
      }
      else
      if(item?.hotelAdminId){
        api= `${API_BASE_URL}${API_PATHS.gethotel}?hotelAdminId=${item?.hotelAdminId}`
     } else{
      api = `${API_BASE_URL}${API_PATHS.gethotel}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }

  

static editHotels(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.edithotel}`;
    return axiosInstance
        .put(api,item)
        
}

  
}

export default HotelService;